<template>
    <div class="detailsContainer">
        <van-row>
            <van-col span="19">
                <div class="detailsText">RECOMPENSA DE RECARGA</div>
            </van-col>
            <van-col span="5">
                <div @click="handleDetailsShow" class="detailIcon detailsTag">
                    <div class="customText">{{ $t('activity.details') }}</div>
                    <van-icon name="arrow" />
                </div>
            </van-col>
        </van-row>
        <van-row class="total_card">
            <van-col span="24" style="display: flex; align-items: center;justify-content: center;">
                <img src="@/assets/rechargeGift/totalCoin.png" alt="" width="18%" class="glow-image">
                <div class="cashBackTotal">{{ $t('activity.cashBackTotal') }}</div>
                <div class="cashBackTotalAmount">{{ formatCurrency(cashbackTotal) }}</div>
                <img src="@/assets/rechargeGift/coin.png" alt="" width="5%">
            </van-col>
        </van-row>
        <div v-if="showDetails">
            <div v-if="isShowTodayCard">
                <CashbackWeekDayCard :createTime="todayDayRewards.date" :total-amount="todayDayRewards.totalAmount"
                    :istodayClaimed="istodayClaimed" :title="title" :day-list="todayDayRewards.rewards" />
            </div>
            <CashbackWeekDayCard v-for="(item, index) in setBetList()" :key="index"
                :createTime="item.lossDate ?? item.createTime" :title="title" :day-count="item.dayCount ?? item.day"
                :activity-status="item.status"
                :total-amount="item.totalBetAmount ?? item.rechargeTotal ?? item.totalBetLoss"
                :istodayClaimed="istodayClaimed" :available-amount="item.remainGiftAmount ?? item.availableAmount"
                :day-list="setdayList(item.dayRewards)" />
        </div>

    </div>
</template>
<script lang="ts" setup>
import { PropType, ref, } from 'vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getBetList, getDayList } from '@/view/components/supportFunction';
import CashbackWeekDayCard from './cashbackWeekDayCard.vue';

const props = defineProps({
    cashbackTotal: {
        type: Number,
        default: () => 0
    },
    betList: {
        type: Array as PropType<any[]>,
        default: () => []
    },
    istodayClaimed: {
        type: Boolean,
        default: () => false
    },
    type: {
        type: String,
        default: () => ''
    },
    title: String,
    todayDayRewards: {
        type: Object as PropType<any>
    },
    isShowTodayCard: {
        type: Boolean,
        default: () => false
    },
})
const showDetails = ref(false)
const handleDetailsShow = () => {
    showDetails.value = !showDetails.value
}
const setdayList = (data: any) => getDayList(props.type, data)
const setBetList = () => getBetList(props.betList, props.isShowTodayCard)
</script>
<style scoped>
.detailsContainer {
    padding: 10px;
    font-family: 'Roboto';
    color: #fff;
    background-color: #130a05ad;
    margin: 5px;
    border-radius: 5px;
    border: 0.5px solid #2e2218;
}

.detailsText {
    color: #a78847;
    font-size: 12px;
    text-transform: uppercase;
}

.detailsTag {
    padding: 5px;
    border-radius: 7px;
    border: 0.5px solid #2e2218;
    color: rgb(243, 230, 218);
}

.detailIcon {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.customText {
    padding-right: 5px;
}

.detailIcon>>>.van-icon {
    color: rgb(254, 201, 155);
    font-size: 11px;
    padding: 2px;
    display: flex;
    align-items: center;
}

.total_card {
    background-color: #16100ede;
    padding: 10px;
    border-radius: 7px;
    border: 0.5px solid #2e2218b6;
    color: rgb(243, 230, 218);
    margin-top: 15px;
}

.total_card img[src*="totalCoin"] {
    background: radial-gradient(circle, rgba(255, 255, 255, 0.4) 0%, rgb(44 40 22 / 23%) 50%, transparent 70%);
    border-radius: 50%;
    padding: 0px 10px;
}

.glow-image {
    width: 18%;
    filter: drop-shadow(0 0 15px rgba(195, 176, 72, 0.551));
}

.cashBackTotal {
    color: #a78847;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
}

.cashBackTotalAmount {
    color: #a78847;
    font-size: 18px;
    padding: 0 10px;
    font-weight: 800;
    text-transform: uppercase;
}
</style>
